const mutation = /* GraphQL */ `
  mutation RegisterUserWithReservationMutation(
    $input: RegisterUserWithReservationInput!
  ) {
    registerUserWithReservationOrError(input: $input) {
      ... on ErrorInterface {
        errorMessage: message
      }
      ... on RegisterUserWithReservationPayload {
        userProfile {
          id
          handle
        }
      }
    }
  }
`;

function commit(environment, input) {
  return environment.commitMutation(mutation, { input });
}

export default { commit };
